<script lang="ts" setup>
import Breadcrumb from '@/components/layout/Breadcrumb.vue'
</script>

<template>
    <section
        class="mx-auto mb-4 flex h-8 w-full max-w-[2200px] items-center justify-between text-xs uppercase lg:mb-6 lg:px-0"
    >
        <div class="hidden lg:flex">
            <Breadcrumb to="/">
                <mdi:home />
            </Breadcrumb>
            <slot />
        </div>

        <div class="flex items-center justify-end space-x-2.5">
            <slot name="actions" />
        </div>
    </section>
</template>
